import { FC } from 'react';
import { useHomePageCustomRowsQuery } from '../../query';
import { RecommendedSlider } from '../RecommendedSlider';

type Props = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  homePageStatus: boolean;
};

const CustomRows: FC<Props> = ({ isMobile, isTablet, isDesktop, homePageStatus }) => {
  const { movies, isLoading, isError } = useHomePageCustomRowsQuery(homePageStatus);

  return (
    <>
      {isLoading && null}
      {isError && <p className="text-black text-center">Server error</p>}
      {movies && Object.keys(movies).length
        ? Object.keys(movies).map((item, index) => {
            const movie = movies[item as keyof typeof movies];
            return (
              <RecommendedSlider
                type={movie.items}
                key={index}
                data={movie.data}
                queryName={`promotions/${movie.promotion_id}`}
                name={movie.title}
                config={movie.config}
                id={movie.id}
              />
            );
          })
        : null}
    </>
  );
};

export default CustomRows;
